import { Mask } from '@/types';
import { loadImage } from '@/utils/image/loadImage';

function getPreviewUrlForMask(mask: Mask) {
  if (mask.contentType === 'image/svg+xml') {
    return `/designer-service/v1/masks/${mask.id}/content`;
  }

  return `/designer-service/v1/masks/${mask.id}/render?width=500`;
}

/**
 * initializes a preview image for a given mask and returns a promise that
 * resolves to a HTMLImage instance
 * @param {*} mask
 */
export const initMaskImage = async (mask: Mask): Promise<HTMLImageElement> =>
  loadImage(getPreviewUrlForMask(mask), true);
